import React from 'react'
import Footer from '../components/Footer/Footer'
import  '../layouts/FooterContainer.css'

function FooterContainer({ containerObject, templateName, contentId, dataZone }) {

  return (
      <>
          <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`footer-parent vast-plugin-content row`} >
                <Footer className="mt-5" containerObject={containerObject}/> 
          </div>
      </>
       )
}

export default FooterContainer